import React, { useRef } from 'react';
import { SVGIcon } from '../../../wrappers/SVGIcon';

import AttachFile from './AttachFile';

import { IAttachedFileWithUrl } from '../../../../interfaces/services';

import { Icons } from '../../../../data/Assets';
import { AttachedFileType } from '../../../../interfaces/job_posts';

interface IFileManagementProps {
    attachedFiles: IAttachedFileWithUrl[];
    filesToUpload: File[];
    handleUploadFile: (file: File) => void;
    handleRemoveFile: (file: File) => void;
    handleRemoveAttachedFile: (file: IAttachedFileWithUrl) => void;
    handlePreviewLocalFile: (file: File) => void;
    handlePreviewAttachedFile: (file: IAttachedFileWithUrl) => void;
    handleDownloadLocalFile: (file: File) => void;
    handleDownloadAttachedFile: (file: IAttachedFileWithUrl) => void;
    handleCloseFileManagement: () => void;
}

const FileManagement = (props: IFileManagementProps) => {
    const { attachedFiles, filesToUpload, handleUploadFile, handleRemoveFile, handleRemoveAttachedFile, handlePreviewLocalFile, handlePreviewAttachedFile, handleDownloadLocalFile, handleDownloadAttachedFile, handleCloseFileManagement } = props;

    const inputRef = useRef<HTMLInputElement>(null);

    const onClickCloseFileManagement = () => {
        handleCloseFileManagement();
    }

    const onClickUploadFile = () => {
        inputRef.current?.click();
    }

    const onChangeUploadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            handleUploadFile(file);
        }
    }

    const onClickRemoveFile = (file: File) => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }

        handleRemoveFile(file);
    }

    const onClickRemoveAttachedFile = (file: IAttachedFileWithUrl) => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }

        handleRemoveAttachedFile(file);
    }

    const onClickPreviewLocalFile = (file: File) => {
        handlePreviewLocalFile(file);
    }

    const onClickPreviewAttachedFile = (file: IAttachedFileWithUrl) => {
        handlePreviewAttachedFile(file);
    }

    const onClickDownloadLocalFile = (file: File) => {
        handleDownloadLocalFile(file);
    }


    const onClickDownloadAttachedFile = (file: IAttachedFileWithUrl) => {
        handleDownloadAttachedFile(file);
    }


    const isEmpty = (filesToUpload.length + attachedFiles.length) === 0;

    return (
        <div className='immployer__file_management'>
            <div className='immployer__file_management__container'>
                <div className='immployer__file_management__container__header'>
                    <h3 className='immployer__file_management__container__header__title'>File Management</h3>
                    <button
                        className='immployer__file_management__container__header__close'
                        onClick={onClickCloseFileManagement}
                    >
                        <SVGIcon src={Icons.X} color='dark_grey' />
                    </button>
                </div>

                <div className='immployer__file_management__container__body'>
                    <button
                        className='immployer__btn immployer__btn__primary immployer__file_management__container__body__upload_btn'
                        onClick={onClickUploadFile}
                    >
                        <SVGIcon src={Icons.Upload} color='white' />
                        <span>Upload File</span>
                    </button>

                    {!isEmpty && <h5 className='immployer__file_management__container__body__title'>Attached Files:</h5>}
                    {isEmpty && <p className='immployer__file_management__container__body__empty_info'>No files attached. Click the upload button to add files.</p>}
                    <input
                        type='file'
                        ref={inputRef}
                        accept='.doc,.docx,.pdf'
                        className='immployer__file_management__container__body__upload_input'
                        onChange={onChangeUploadFile}
                    />

                    <div className='immployer__file_management__container__body__files'>
                        {filesToUpload.map((file) => (
                            <AttachFile
                                key={file.name}
                                name={file.name}
                                disablePreview={file.type !== 'application/pdf'}
                                onPreviewFile={() => onClickPreviewLocalFile(file)}
                                onRemoveFile={() => onClickRemoveFile(file)}
                                onDownloadFile={() => onClickDownloadLocalFile(file)}
                            />
                        ))}

                        {attachedFiles.map((file) => (
                            <AttachFile
                                key={file.id}
                                name={file.asset_name}
                                disablePreview={file.type !== AttachedFileType.PDF}
                                onPreviewFile={() => onClickPreviewAttachedFile(file)}
                                onRemoveFile={() => onClickRemoveAttachedFile(file)}
                                onDownloadFile={() => onClickDownloadAttachedFile(file)}
                            />
                        ))}
                    </div>
                </div>

                <div className='immployer__file_management__container__footer'>
                    <button
                        className='immployer__btn immployer__btn__secondary immployer__file_management__container__footer__save_btn'
                        onClick={onClickCloseFileManagement}
                    >
                        <span>Done</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FileManagement;